import { useEffect, useState } from "react";
import HeaderToggle from "./doubleauth/HeaderToggle";
import QrCodeSetup from "./doubleauth/QrCodeSetup";
import TwoFaEnabled from "./doubleauth/TwoFaEnabled";
import DisableFlow from "./doubleauth/Disable2Fa";
import "./authenti.css";

const DoubleAuthSetting = ({ username }) => {
  
  const authUser =JSON.parse(sessionStorage.getItem("authUser"));
  const twoFaEnabled = authUser?.user?.twoFaEnabled;
  
  const [isEnabled, setIsEnabled] = useState(!!twoFaEnabled);

  useEffect(() => {
    setIsEnabled(!!twoFaEnabled);
  }, [twoFaEnabled]);

  return (
    <div className="double-auth-container">
      <h5 className="mt-2 mb-4">Authentification à double facteur</h5>
      <HeaderToggle isEnabled={isEnabled} setIsEnabled={setIsEnabled} />

      <div className="auth-content">
        {isEnabled ? (
           twoFaEnabled ? (
            <TwoFaEnabled />
          ) : (
            <QrCodeSetup username={username} currentUser={authUser} />
          )
        ) : (
           <DisableFlow username={username} twoFaEnabled={twoFaEnabled} />
        )}
      </div>
    </div>
  );
};

export default DoubleAuthSetting;
